export default function PrinciplesPanel() {
  return (
    <section className="panel" data-side="bottom" id="stewardship" aria-labelledby="stewardship-heading">
      <img
        className="panel-bg"
        src="https://readdy.ai/api/search-image?query=Tall%20window%20frame%20in%20a%20deep%20spring%20green%20room%20with%20ivy%20leaves%20pressed%20against%20the%20glass%2C%20soft%20honeyed%20daylight%20falling%20through%20onto%20a%20pale%20wooden%20chair%20and%20a%20stone%20floor%2C%20quiet%20empty%20interior%2C%20warm%20muted%20tones%2C%20elegant%20architectural%20still%20life%20photography%20with%20no%20people&width=2400&height=1350&seq=reve-stewardship-window&orientation=landscape"
        alt="Ivy against a tall window in a green room, with honeyed daylight falling onto an empty chair."
        width="2400"
        height="1350"
        loading="eager"
        fetchPriority="low"
        decoding="async"
        data-parallax="0.32"
      />
      <div className="panel-veil" aria-hidden="true" />
      <span className="panel-accent rule" data-parallax="0.55" aria-hidden="true" />

      <div className="panel-copy" data-parallax="-0.08">
        <p className="stamp" data-reveal>
          05 — Stewardship
        </p>
        <h2 id="stewardship-heading" data-reveal>
          Held with care,
          <br />
          answered <em className="accent">for.</em>
        </h2>
        <p className="sub" data-reveal>
          Resources entrusted to a foundation are not ours to spend quickly. We keep our process
          simple and unhurried — a considered question, a clear reason, and a decision we can
          explain.
        </p>
        <ul className="bullets">
          <li data-reveal>Decisions weighed deliberately, without urgency or pressure.</li>
          <li data-reveal>A long horizon that favours durable work over quick results.</li>
          <li data-reveal>Correspondence handled personally and in confidence.</li>
        </ul>
        <a className="cta" href="#contact" data-reveal>
          Contact the foundation
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </a>
      </div>
    </section>
  );
}